import api from '../api/axiosInstance';

export const moshellService = {
  getAll: () => api.get('/api/moshell-endpoint'),
  getById: (id: string) => api.get(`/api/moshell-endpoint/${id}`),
  getNodes: (id: string) => api.get(`/api/moshell-endpoint/nodes/${id}`)
};
